import { gql } from 'apollo-angular';

const UPLOAD_PRODUCT_APPLY_CHANGES_REQUEST = gql`
  mutation applyChanges($uploadRequestId: Long!) {
    applyChangesRequest(
      applyChangesRequest: { uploadRequestId: $uploadRequestId }
    ) {
      success
    }
  }
`;

export default UPLOAD_PRODUCT_APPLY_CHANGES_REQUEST;
